<div class="map-wrapper" #htmlMapWrapper>
  <ngui-map *ngIf="mapEnabled" [options]="mapOptions">
    <app-listing-marker  *ngIf="listing" [marker]="marker" [position]="[marker.lat, marker.lng]"></app-listing-marker>
    <app-plain-marker *ngIf="isOffice" [marker]="marker" [position]="[marker.lat, marker.lng]"></app-plain-marker>
  </ngui-map>
</div>
